import type { IAccountPartnerAttributes } from './AccountPartnerAttributes.interface';
import Address from '../address/Address';

export default class AccountPartnerAttributes implements IAccountPartnerAttributes {
  id: string;
  idOwners: Array<string>;
  code: string;
  ran: string;
  companyName: string;
  officeName: string;
  phonePrefix: string;
  phoneNumber: string;
  address: Address;
  bankAccounts: {
    name1: string,
    bsbNumber1: string,
    number1: string,
    name2: string,
    bsbNumber2: string,
    number2: string,
    name3: string,
    bsbNumber3: string,
    number3: string
  };

  fee: number;
  upfront: number;
  upfrontPercentage: number;
  trail: number;
  trailPercentage: number;
  referrerType: string;
  referrerCode: string;
  companyReferrerCode: string;
  commissionUsername: string;
  commissionPassword: string;

  static build = (data: IAccountPartnerAttributes) => new AccountPartnerAttributes(data);
  static blank = () => new AccountPartnerAttributes();

  /**
   * Constructor
   * @param {IAccountPartnerAttributes} data
   */
  constructor(data?: IAccountPartnerAttributes) {
    this.id = data?.id || undefined;
    this.idOwners = data?.idOwners || undefined;
    this.code = data?.code || undefined;
    this.ran = data?.ran || undefined;
    this.companyName = data?.companyName || undefined;
    this.officeName = data?.officeName || undefined;
    this.phonePrefix = data?.phonePrefix || undefined;
    this.phoneNumber = data?.phoneNumber || undefined;
    this.address = new Address(data?.address);
    this.bankAccounts = data?.bankAccounts || {
      name1: '',
      bsbNumber1: '',
      number1: '',
      name2: '',
      bsbNumber2: '',
      number2: '',
      name3: '',
      bsbNumber3: '',
      number3: ''
    };
    this.fee = data?.fee || undefined;
    this.upfront = data?.upfront || undefined;
    this.upfrontPercentage = data?.upfrontPercentage || undefined;
    this.trail = data?.trail || undefined;
    this.trailPercentage = data?.trailPercentage || undefined;
    this.referrerType = data?.referrerType || undefined;
    this.referrerCode = data?.referrerCode || undefined;
    this.companyReferrerCode = data?.companyReferrerCode || undefined;
    this.commissionUsername = data?.commissionUsername || undefined;
    this.commissionPassword = data?.commissionPassword || undefined;
  }
}
